import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-volt-template',
  templateUrl: './volt-template.component.html',
  styleUrls: ['./volt-template.component.less']
})
export class VoltTemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
